import { Box, Button, Stack, Typography } from '@mui/material';
import ModalV2 from '/@/components/bayer/modal-v2';
import Markdown from '/@/components/markdown';
import { _ } from '/@/locale';
import { modalProps } from '.';
import AdvisorLinkIcon from './assets/advisor-link.svg';
import FieldsIcon from './assets/fields.svg';
import RVLinkIcon from './assets/rv-link.svg';
import UsersIcon from './assets/users.svg';

const RVOnboardingModalInitial = ({
    isRV = true,
    open,
    onClose,
    onNext,
}: {
    isRV: boolean;
    open: boolean;
    onClose: () => void;
    onNext: () => void;
}) => {
    const infoCols = isRV
        ? [
              {
                  icon: <Box component='img' src={AdvisorLinkIcon} height='160px' width='160px' />,
                  title: _('Vinculate con tus Asesores'),
                  description: _(
                      'Ahora podés vincularte con los Asesores con los que trabajas y compartir la información de los productores Premium.'
                  ),
              },
              {
                  icon: <Box component='img' src={UsersIcon} height='160px' width='160px' />,
                  title: _('Gestioná a tus productores Premium'),
                  description: _(
                      'Incorporamos una nueva organización por tipo de productor, diferenciando a los Premium de otros segmentos.'
                  ),
              },
              {
                  icon: <Box component='img' src={FieldsIcon} height='160px' width='160px' />,
                  title: _('Asigná los lotes de cada productor'),
                  description: _(
                      'En la sección **Mis lotes** podés asignar lotes a cada productor y mantener la información ordenada.'
                  ),
              },
          ]
        : [
              {
                  icon: <Box component='img' src={RVLinkIcon} height='160px' width='160px' />,
                  title: _('Vinculate con el RV con quien trabajas'),
                  description: _(
                      'De esta manera podrán compartir la información de los productores Premium y sus lotes de forma segura.'
                  ),
              },
              {
                  icon: <Box component='img' src={UsersIcon} height='160px' width='160px' />,
                  title: _('Gestioná a tus productores Premium'),
                  description: _(
                      'Incorporamos una nueva organización por tipo de productor, diferenciando a los Premium de otros segmentos.'
                  ),
              },
              {
                  icon: <Box component='img' src={FieldsIcon} height='160px' width='160px' />,
                  title: _('Asigná los lotes de cada productor'),
                  description: _(
                      'En la sección **Mis lotes** podés asignar lotes a cada productor y mantener la información ordenada.'
                  ),
              },
          ];

    const modalElements = [
        {
            enabled: isRV,
            title: _('Trabajá mejor con tus Asesores en Experto'),
            description: _(
                'Te presentamos nuevas herramientas para organizar productores y lotes, colaborar de forma integrada con los Asesores y gestionar toda la información clave desde un solo lugar.'
            ),
            actions: [
                <Button key='continue' variant='text' color='secondary' onClick={onClose}>
                    {_('Continuar sin vincularme')}
                </Button>,
                <Button key='link' variant='contained' color='secondary' onClick={onNext}>
                    {_('Vincularme con mis Asesores')}
                </Button>,
            ],
        },
        {
            enabled: !isRV,
            title: _('Te damos la bienvenida a la nueva experiencia de Asesor Agronómico'),
            description: _(
                'Experto cuenta con nuevas herramientas para organizar productores y lotes, colaborar de forma integrada con el RV y gestionar toda la información clave desde un solo lugar.'
            ),
            actions: [
                <Button key='continue' variant='text' color='secondary' onClick={onClose}>
                    {_('Continuar sin vincularme')}
                </Button>,
                <Button key='link' variant='contained' color='secondary' onClick={onNext}>
                    {_('Vincularme con mi RV')}
                </Button>,
            ],
        },
    ];

    const modalElement = modalElements.find((element) => element.enabled) ?? modalElements[0];

    return (
        <ModalV2
            open={open}
            onClose={onClose}
            title={modalElement?.title}
            actions={modalElement?.actions}
            {...modalProps}
        >
            <Typography variant='body1' color='primary' maxWidth='800px'>
                {modalElement?.description}
            </Typography>
            <Stack direction='row' spacing={4} width='100%'>
                {infoCols.map((col) => (
                    <Stack key={col.title} spacing={4} justifyContent='center' alignItems='center'>
                        {col.icon}
                        <Stack>
                            <Typography variant='subtitle1' color='primary' fontWeight='bold'>
                                {col.title}
                            </Typography>
                            <Markdown>{col.description}</Markdown>
                        </Stack>
                    </Stack>
                ))}
            </Stack>
        </ModalV2>
    );
};

export default RVOnboardingModalInitial;
